import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { signIn } from '../hooks';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
export default function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();
    const [params] = useSearchParams();
    const next = params.get('next') ?? '/app/dashboard';
    async function submit(e) {
        e.preventDefault();
        setError(null);
        setBusy(true);
        try {
            const { error } = await signIn(email, password);
            if (error)
                throw error;
            nav(next);
        }
        catch (err) {
            setError(err?.message?.includes('Invalid login')
                ? "That email and password don't match. Double-check and try again."
                : err?.message ?? 'Something went wrong signing in.');
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx("main", { id: "main", className: "min-h-dvh grid place-items-center bg-gradient-to-br from-slate-50 to-white px-4", children: _jsxs("form", { onSubmit: submit, className: "w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl ring-1 ring-slate-200", children: [_jsx("h1", { className: "text-2xl font-semibold tracking-tight text-slate-900", children: "Welcome back" }), _jsx("p", { className: "mt-1 text-sm text-slate-500", children: "Sign in to ReviewRadar." }), _jsxs("div", { className: "mt-6 space-y-4", children: [_jsx(Input, { label: "Email", type: "email", autoComplete: "email", required: true, value: email, onChange: (e) => setEmail(e.target.value) }), _jsx(Input, { label: "Password", type: "password", autoComplete: "current-password", required: true, value: password, onChange: (e) => setPassword(e.target.value) })] }), error && _jsx("p", { role: "alert", className: "mt-3 text-sm text-red-600", children: error }), _jsx(Button, { type: "submit", disabled: busy, className: "mt-6 w-full", children: busy ? 'Signing in…' : 'Sign in' }), _jsxs("p", { className: "mt-4 text-center text-sm text-slate-500", children: ["New here? ", _jsx(Link, { to: "/signup", className: "font-medium text-brand-700 underline-offset-4 hover:underline", children: "Create an account" })] })] }) }));
}
